import { render, staticRenderFns } from "./TestKitDetail.vue?vue&type=template&id=23603910&scoped=true"
import script from "./TestKitDetail.vue?vue&type=script&lang=js"
export * from "./TestKitDetail.vue?vue&type=script&lang=js"
import style0 from "./TestKitDetail.vue?vue&type=style&index=0&id=23603910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23603910",
  null
  
)

export default component.exports